import { createFileRoute } from "@tanstack/react-router";

import { ErrorState, Page, Skeleton } from "@/components/ui";

import { ActivityConfig } from "../features/console";
import { useCatalogEntry } from "../features/console/activities/lib/queries";

/** One catalog entry, before anything has added it. */
export const Route = createFileRoute("/console/activities/$activityId")({
  component: ActivityRoute,
});

function ActivityRoute() {
  const { activityId } = Route.useParams();
  const { entry, query } = useCatalogEntry(activityId);

  if (query.isPending) {
    return (
      <Page eyebrow="Account" title={activityId} measure="wide">
        <Skeleton height="240px" />
      </Page>
    );
  }
  if (entry === undefined) {
    return (
      <ErrorState
        headline="No such activity"
        {...(query.error === null ? {} : { code: query.error.message })}
        onRetry={() => {
          void query.refetch();
        }}
      />
    );
  }
  return <ActivityConfig entry={entry} root={null} space={null} />;
}
